import { render, staticRenderFns } from "./qs2-02.vue?vue&type=template&id=7cca126b&scoped=true&"
import script from "./qs2-02.vue?vue&type=script&lang=js&"
export * from "./qs2-02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cca126b",
  null
  
)

export default component.exports